import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../Button';

import './styles.less';

const ButtonGroup = (props) => {
    const { variant, useLinkAsBtn = false} = props;
    const pbuttongroupAttributes = {
        className: classNames({
            'p-button-group': true,
            'p-button-group--full-width': props.isFullWidth,
            'p-button-group--spaced': props.isSpaced,
            [props.className]: props.className
        }),
        role: 'group',
        'data-cid': props.contentId
    };

    return (
        <div {...pbuttongroupAttributes}>
            {props.buttons.map((btn, i) => {
                const buttonProps = {
                    ...btn,
                    variant,
                    size: props.size,
                    key: i,
                    useLinkAsBtn: useLinkAsBtn
                };
                return <Button {...buttonProps} />;
            })}
        </div>
    );
};

const LiteButtonProps = {
    centered: PropTypes.bool,
    text: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
    className: PropTypes.string,
    openInNewTab: PropTypes.bool,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    contentId: PropTypes.string
};

ButtonGroup.propTypes = {
    variant: PropTypes.oneOf(['primary', 'secondary', 'purchase', 'tickets', 'product']).isRequired,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    isFullWidth: PropTypes.bool,
    isSpaced: PropTypes.bool,
    buttons: PropTypes.arrayOf(PropTypes.shape(LiteButtonProps)).isRequired,
    contentId: PropTypes.number,
    className: PropTypes.string
};

ButtonGroup.defaultProps = {
    variant: 'primary',
    size: 'md',
    isFullWidth: false,
    isSpaced: false,
    contentId: undefined,
    className: undefined
};

export default ButtonGroup;
